import Iconify from "../../Iconify";

const BgIcon = ({ className, icon, onClick, IconclassName }) => {
  return (
    <div
      className={`group flex justify-center items-center w-9 h-9 rounded-full dark:hover:bg-brown hover:bg-light_bg_grey cursor-pointer ${className}`}
      onClick={onClick}
    >
      <Iconify
        icon={icon}
        className={`w-5 h-5 dark:group-hover:!text-dark_primary_label group-hover:!text-light_primary_label dark:!text-dark_secondary_label  text-light_secondary_label ${IconclassName}`}
      />
    </div>
  );
};

export default BgIcon;
